<!--CV-RL 详情-->
<template>
  <div class="mentee-cl-rl-detail">
    <cv-rl-list :data="cvData"
                title="Reference Letter"
                @on-upload='handleUpload'
                @on-feedback="handleFeedback"></cv-rl-list>
    <!-- 讨论区列表 -->
    <cv-rl-discuss-list ref="discussList"
                        :data="discussData"
                        style="display:none;"></cv-rl-discuss-list>
    <!-- 添加讨论 -->
    <cv-rl-add-discuss :data="discussData"
                       @on-success="handleAddDiscuss"
                       style="display:none;"></cv-rl-add-discuss>
    <!-- 上传cv-rl -->
    <cv-rl-upload ref="upload"
                  :upData='upData'
                  @sub-upload="subUploadHandle"></cv-rl-upload>
    <!-- 查看feedback -->
    <cv-rl-feedback ref="feedback"
                    :data="feedbackData"></cv-rl-feedback>
    <!-- Service note -->
    <service-note type='RL'></service-note>
  </div>
</template>
<script>
// api
import { getMeterialSingleRLList, subMaterialUploadRl } from '@/api/material'
// components
import CvRlList from './cv-rl/cv-rl-list'
import CvRlDiscussList from './cv-rl/discuss-list'
import CvRlAddDiscuss from './cv-rl/add-discuss'
import CvRlUpload from './cv-rl/cv-rl-upload'
import CvRlFeedback from './cv-rl/feedback'
import ServiceNote from './cv-rl/service-note'
// constant
import { uploadSuc } from '@/constant'
export default {
  name: 'mentee-cvrl-cv-detail',
  components: {
    CvRlList,
    CvRlDiscussList,
    CvRlAddDiscuss,
    CvRlUpload,
    CvRlFeedback,
    ServiceNote
  },
  data () {
    return {
      num: this.$route.query.billId,
      cvData: {},
      discussData: {
        billId: this.$route.query.billId,
        type: 'RL'
      },
      upData: {},
      feedbackData: {}
    }
  },
  computed: {},
  mounted () {
    this.getMeterialList()
  },
  methods: {
    getMeterialList () {
      getMeterialSingleRLList({
        id: this.num
      }).then(res => {
        this.cvData = res.data.model
      })
    },
    // 发表评论成功
    handleAddDiscuss () {
      this.$refs['discussList'].getCommentsPage()
    },
    // 上传
    handleUpload (data) {
      this.upData = data
      this.$refs['upload'].showHandle('RL')
    },
    // 上传操作
    subUploadHandle (data) {
      let params = {
        ...data,
        id: this.upData.itemId
      }
      subMaterialUploadRl(params).then(res => {
        this.$refs['upload'].handleUploadSuc()
        this.$zlr_message(uploadSuc, 'success')
        this.getMeterialList()
      }).catch(error => {
        this.$refs['upload'].handleUploadRrror()
        this.$zlr_message(error.message, 'error')
      })
    },
    // 查看feedback
    handleFeedback (data) {
      this.feedbackData = data
      this.$refs['feedback'].handleShow()
    }
  }
}
</script>
<style lang='less' scoped>
</style>
